import React, { FC } from 'react';

const PreviewIcon: FC = () => {
    return (
        <svg className="svg-inline" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.778 11.971C11.6985 11.971 12.4447 11.2248 12.4447 10.3044C12.4447 9.38389 11.6985 8.6377 10.778 8.6377C9.85752 8.6377 9.11133 9.38389 9.11133 10.3044C9.11133 11.2248 9.85752 11.971 10.778 11.971Z"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.112 10.3045C16.8895 14.1937 14.112 16.1379 10.7786 16.1379C7.44531 16.1379 4.66781 14.1937 2.44531 10.3045C4.66781 6.41536 7.44531 4.47119 10.7786 4.47119C14.112 4.47119 16.8895 6.41536 19.112 10.3045Z"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default PreviewIcon;
